import { Color } from '@lib/sanity/sanity.types';
import { PortableTextProjection } from '@lib/sanity/types/common';
import IconType from '@ui/Icon/StaticIcon/IconType';
import { StaticIcon } from '@ui/Icon/StaticIcon/StaticIcon';
import { TextVariant } from '@ui/Text/constants';
import PortableText from '@ui/Text/PortableText';
import cn from '@utils/cn';

type Props = {
  mostPopularChipColor?: Color['rgb'];
  mostPopularTextColor?: Color['rgb'];
  content?: PortableTextProjection;
};

const MostPopularTag = ({ mostPopularChipColor, mostPopularTextColor, content }: Props) => {
  return (
    <div
      className={cn('flex shrink-0 items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium')}
      style={{
        backgroundColor: `rgba(${mostPopularChipColor?.r},${mostPopularChipColor?.g},
                ${mostPopularChipColor?.b},${mostPopularChipColor?.a})`,
      }}
    >
      <StaticIcon icon={IconType.star} className="size-3.5" />
      <PortableText
        content={content}
        variant={TextVariant.TextUnicase}
        style={{
          color: `rgba(${mostPopularTextColor?.r},${mostPopularTextColor?.g},
                    ${mostPopularTextColor?.b},${mostPopularTextColor?.a})`,
          padding: 0,
        }}
      />
    </div>
  );
};

export default MostPopularTag;
